import { createContext, useMemo, useState } from "react";

const GeaoAgencyInterview = "GeaoAgencyInterview";
const GeaoAgentInterview = "GeaoAgentInterview";
const GeaoBranchInterview1 = "GeaoBranchInterview1";
const GeaoBranchInterview2 = "GeaoBranchInterview2";

export const GeaoContext = createContext();

export default function GeaoContextProvider({ children }) {
    const [agencyInterview, setAgencyInterview] = useState(JSON.parse(sessionStorage.getItem(GeaoAgencyInterview)));
    const [agentInterview, setAgentInterview] = useState(JSON.parse(sessionStorage.getItem(GeaoAgentInterview)));
    const [branchInterview1, setBranchInterview1] = useState(JSON.parse(sessionStorage.getItem(GeaoBranchInterview1)));
    const [branchInterview2, setBranchInterview2] = useState(JSON.parse(sessionStorage.getItem(GeaoBranchInterview2)));

    const geaoContext = useMemo(() => {
        return {
            agencyInterview,
            setAgencyInterview: agencyInterview => {
                sessionStorage.setItem(GeaoAgencyInterview, JSON.stringify(agencyInterview));
                setAgencyInterview(agencyInterview);
            },
            agentInterview,
            setAgentInterview: agentInterview => {
                sessionStorage.setItem(GeaoAgentInterview, JSON.stringify(agentInterview));
                setAgentInterview(agentInterview);
            },
            branchInterview1,
            setBranchInterview1: branchInterview1 => {
                sessionStorage.setItem(GeaoBranchInterview1, JSON.stringify(branchInterview1));
                setBranchInterview1(branchInterview1);
            },
            branchInterview2,
            setBranchInterview2: branchInterview2 => {
                sessionStorage.setItem(GeaoBranchInterview2, JSON.stringify(branchInterview2));
                setBranchInterview2(branchInterview2);
            },
            interviewIsCompleted: agentInterview?.outcome === "Complete"
        }
    }, [
        agencyInterview,
        agentInterview,
        branchInterview1,
        branchInterview2
    ]);

    return <GeaoContext.Provider value={geaoContext}>{children}</GeaoContext.Provider>;
}